import { IconButton, Stack, Typography } from "@mui/material"
import Avatar from "../../Tools/Avatar"
import moment from "moment"
import { ArrowBack, Delete, Edit } from "@mui/icons-material"
import { Link, useNavigate } from "react-router-dom"
import API from "../../../services/API"
import ToastContext from "../../../services/Context/ToastContext"
import { useContext } from "react"
import { txt } from "../../../services/translation"

export default function Top({data}){

    const navigate = useNavigate()

    const {setToast} = useContext(ToastContext)

    const handleDelete = () => {

        const ok = window.confirm(txt('confirmUserDeletion'));
    
        if(!ok) return false;
    
        API.delete(`/companies/me/users/${data.id}`)
            .then(r => setToast({
                severity: 'info', 
                message: txt('userDeletedMessage', { name: data.name }), 
                duration: 5000
            }))
            .catch(_ => setToast({
                severity: 'error', 
                message: txt('userDeletionErrorMessage', { name: data.name }), 
                duration: 5000
            }));
    
        navigate('/company')
    }
    

    return <Stack direction='row' justifyContent='space-between'>

        <Stack direction='row' alignItems='center' spacing={1}>

            <IconButton onClick={() => navigate(-1)}>
                <ArrowBack/>
            </IconButton>

            <Stack direction='row' spacing={2} alignItems='center'>

                <Avatar
                    color={data.category?.color}
                    initials={data.initials}
                    size={54}
                />

                <Stack>
                    <Typography variant='h3'>{data.name}</Typography>
                    <Typography variant='small'>{txt('accountCreatedOn')} {moment(data.createdAt).format('DD/MM/YYYY')}</Typography>
                </Stack>

            </Stack>

        </Stack>

        <Stack direction='row' alignItems='center' spacing={1}>
            <Link to={`/company/contacts/${data.id}/edit`}>
                <IconButton>
                    <Edit />
                </IconButton>
            </Link>
            <IconButton onClick={handleDelete}>
                <Delete/>
            </IconButton>
        </Stack>

    </Stack>
}